type Props = { features?: string[] };

export function BidBudgetEnginePanel({ features = [] }: Props) {
  const active = ['AI Bids', 'Profit-based Bids', 'Inventory-aware Bids'];
  return (
    <div className="space-y-3">
      <div className="grid gap-2 grid-cols-2 sm:grid-cols-3">
        {features.map((f) => (
          <div
            key={f}
            className={`rounded-lg border p-3 text-xs font-medium ${
              active.includes(f)
                ? 'border-brand-300 bg-brand-50 text-brand-700 dark:border-brand-700 dark:bg-brand-950 dark:text-brand-300'
                : 'border-slate-200 text-slate-600 dark:border-slate-700 dark:text-slate-400'
            }`}
          >
            {f}
            {active.includes(f) && <span className="mt-1 block text-xs font-normal opacity-70">Active</span>}
          </div>
        ))}
      </div>
      <div className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
        <p className="text-xs text-slate-500">Today's bid adjustments</p>
        <p className="mt-1 text-sm font-semibold">127 bids optimized · ₹18.4K saved waste · +0.3x ROAS</p>
      </div>
    </div>
  );
}
